function GoogleMap(args) {
    "use strict";

    this.version = "1.0";
    
    var defargs = {
        debug: false,
        elmid: "",
        styles: null,
        mapaddress: "",
        mapcontent: "",
        maplat: "",
        maplon: "",
        mapzoom: 15,
        icon: "",
        openinfo: false,
        interactive: false
    };

    $.extend(defargs, args);

    var dragFlag = false;
    var start = 0, end = 0;

    var mapoptions = {
        zoom: defargs.mapzoom,
        scrollwheel: false,
        zoomControl: true,
        zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL,
            position: google.maps.ControlPosition.LEFT_CENTER
        },
        mapTypeControl: false,
        mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.DEFAULT,
            position: google.maps.ControlPosition.RIGHT_CENTER
        },
        streetViewControl: false,
        streetViewControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP
        },        
        scaleControl: false,
        panControl: false,
        draggable: defargs.interactive,

        mapTypeId: 'Styled'
    };

    var marker = null;
    
    // The Map Object
    var map = new google.maps.Map(document.getElementById(defargs.elmid), mapoptions);

    var styledMapType = new google.maps.StyledMapType(defargs.styles, { name: 'Styled' });
    map.mapTypes.set('Styled', styledMapType);

    if (defargs.mapaddress.length > 0) {
        var address = "";
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ "address": defargs.mapaddress }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                address = results[0].geometry.location;

                map.setCenter(results[0].geometry.location);

                marker = new google.maps.Marker({
                    position: address,
                    map: map,
                    clickable: true,
                    icon: {
                        url: defargs.icon
                    }
                });

                if (defargs.mapcontent.length > 0) {
                    var infowindow = new google.maps.InfoWindow({ content: defargs.mapcontent });
                    google.maps.event.addListener(marker, "click", function () {
                        infowindow.open(map, marker);
                    });
                }
            }
        });
    }
    else if (defargs.maplat.length > 0 && defargs.maplon.length > 0) {
        marker = new google.maps.Marker({
            position: new google.maps.LatLng(defargs.maplat, defargs.maplon),
            map: map,
            clickable: true,
            icon: {
                url: defargs.icon
            }
        });

        if (marker !== null) {
            map.setCenter(marker.getPosition());

            if (defargs.mapcontent.length > 0) {
                var infowindow = new google.maps.InfoWindow({ content: defargs.mapcontent });
                google.maps.event.addListener(marker, "click", function () {
                    infowindow.open(map, marker);
                });

                if (defargs.openinfo) infowindow.open(map, marker);
            }
        }
    }

    $(window).resize(function () {
        if (map !== null && marker !== null) {
            setTimeout(function () {
                google.maps.event.trigger(map, 'resize'); // recalculate bounds
                map.panTo(marker.getPosition());
            }, 500);
        }
    });

    if (!defargs.interactive) {
        document.getElementById(defargs.elmid).addEventListener("touchstart", mapTouchStart, true);
        document.getElementById(defargs.elmid).addEventListener("touchend", mapTouchEnd, true);
        document.getElementById(defargs.elmid).addEventListener("touchmove", mapTouchMove, true);
    }

    function mapTouchStart(e) {
        dragFlag = true;
        start = e.touches[0].pageY;
    }

    function mapTouchEnd() {
        dragFlag = false;
    }

    function mapTouchMove(e) {
        if (!dragFlag) return;
        
        end = e.touches[0].pageY;
        window.scrollBy(0, (start - end));
    }
}